import React from 'react'

import type { ButtonProps } from '@fourthwall/components'
import { BaseContent, Button, useMediaQueryContext } from '@fourthwall/components'

import * as S from './ShippingGroupEmptyState.styled'

type ShippingGroupEmptyStateProps = {
  to: ButtonProps['to']
}

export const ShippingGroupEmptyState = ({ to }: ShippingGroupEmptyStateProps) => {
  const media = useMediaQueryContext()

  return (
    <S.Container>
      <S.TextualContent>
        <S.Title>Shipping group</S.Title>
        <BaseContent>Select the products you’d like to set shipping limitations for</BaseContent>
      </S.TextualContent>
      <S.ButtonWrapper>
        <Button
          appearance="primary"
          label={media.tablet ? 'Select products to limit shipping to' : 'Select products'}
          to={to}
        />
      </S.ButtonWrapper>
    </S.Container>
  )
}
